import React, { useState, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { photosType } from './ImageList';
import IconClose from '../../../assets/icon/ic-close-mobile@2x.png';

const DetailViewMobileComponent = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: white;
  top: 0px;
  left: 0px;
  z-index: 30;
`;

const DetailViewComponent = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;
const DetailViewImgAnchor = styled.a``;
const DetailViewImg = styled.img`
  width: 100%;
`;

const DetailViewTitle = styled.div`
  font-family: 'NotoKrR';
  display: flex;
  color: #1a0dab;
  width: fit-content;

  font-size: 15px;
  margin-bottom: 3px;
  margin-top: 12px;
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }
`;
const DetailViewDesc = styled.div`
  font-family: 'NotoKrL';
  max-height: 150px;
  color: #222222;
  font-size: 13px;
  margin-bottom: 3px;
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }
`;
const DetailViewSource = styled.div`
  font-family: 'NotoKrR';
  color: #999999;
  font-size: 14px;
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

const DetailViewTitleAnchor = DetailViewTitle.withComponent('a');
const DetailViewDescAnchor = DetailViewDesc.withComponent('a');

const BackButton = styled.img`
  position: absolute;
  left: 16px;
  top: 12px;
  height: 24px;
`;

interface DetailViewMobileProps {
  setIsDetailViewMobile: (isDetailViewMobile: boolean) => void;
  selectPhoto: photosType['photo'] | null | undefined;
}

const DetailViewMobile = ({
  setIsDetailViewMobile,
  selectPhoto,
}: DetailViewMobileProps) => {
  return (
    <DetailViewMobileComponent>
      <BackButton
        src={IconClose}
        onClick={() => {
          setIsDetailViewMobile(false);
        }}
      />
      <DetailViewComponent id="DetailViewComponent">
        {selectPhoto ? (
          <>
            <DetailViewImgAnchor href={selectPhoto.url} target="_blank">
              <DetailViewImg src={selectPhoto.src} />
            </DetailViewImgAnchor>

            {selectPhoto.title ? (
              <DetailViewTitleAnchor
                href={selectPhoto.url}
                target="_blank"
                dangerouslySetInnerHTML={{
                  __html: selectPhoto.title,
                }}
              />
            ) : null}
            {selectPhoto.desc ? (
              <DetailViewDescAnchor
                href={selectPhoto.url}
                target="_blank"
                dangerouslySetInnerHTML={{
                  __html: selectPhoto.desc,
                }}
              />
            ) : null}

            <DetailViewSource>{selectPhoto.source}</DetailViewSource>
          </>
        ) : null}
      </DetailViewComponent>
    </DetailViewMobileComponent>
  );
};

export default DetailViewMobile;
